import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hospitals: [],
  currentHospital: null,
  loading: false,
  error: null,
};

const hospitalSlice = createSlice({
  name: 'hospitals',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setHospitals: (state, action) => {
      state.hospitals = action.payload;
      state.loading = false;
    },
    addHospital: (state, action) => {
      state.hospitals.push(action.payload);
    },
    updateHospital: (state, action) => {
      const index = state.hospitals.findIndex(h => h.id === action.payload.id);
      if (index !== -1) {
        state.hospitals[index] = action.payload;
      }
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setLoading, setHospitals, addHospital, updateHospital, setError } = hospitalSlice.actions;
export default hospitalSlice.reducer;